import Svg from 'components/utilities/svg'

const DocumentOffIcon = ({ ...props }) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <title>Document Off Icon</title>
    <path d="M2.36827202,4.28811691 L3.99905845,5.919 L3.99905845,5.913 L10.0860585,12 L10.0800585,12 L12.0800585,14 L12.0860585,14 L14.0860585,16 L14.0800585,16 L15.9990585,17.919 L15.9990585,17.913 L19.4550415,21.3697892 C19.4544194,21.3704455 19.4537968,21.3711015 19.4531736,21.3717573 L20.0459415,21.9657864 L18.631728,23.38 L17.2510585,22 L6,22 C5.45,22 4.97933333,21.8043333 4.588,21.413 C4.196,21.021 4,20.55 4,20 L3.99905845,8.747 L0.954058454,5.70233047 L2.36827202,4.28811691 Z M14,2 L20,8 L19.9990585,19.085 L14.9140585,14 L16,14 L16,12 L12.9140585,12 L4.14679201,3.23475003 C4.24479196,2.99905539 4.39186129,2.78313871 4.588,2.587 C4.97933333,2.19566667 5.45,2 6,2 L14,2 Z M11.2510585,16 L8,16 L8,18 L13.2510585,18 L11.2510585,16 Z M7.99905845,12.747 L8,14 L9.25205845,14 L7.99905845,12.747 Z M13,4 L13,9 L18,9 L13,4 Z" />
  </Svg>
)

DocumentOffIcon.displayName = 'DocumentOff'

export default DocumentOffIcon
